import { render, staticRenderFns } from "./IbWarningModal.vue?vue&type=template&id=7762b6ed"
import script from "./IbWarningModal.vue?vue&type=script&lang=js"
export * from "./IbWarningModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports